export default {"src":"/_next/static/media/Search-white.577d2aea.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};